import { IAction } from '@r1-frontend/shared/types/Redux';

import { ECartActionTypes } from '../actionTypes';
import { ICartState } from '../types';

export const hydrateCart = (payload: ICartState): IAction<ECartActionTypes.HYDRATE_CART, ICartState> => ({
    type: ECartActionTypes.HYDRATE_CART,
    payload,
});
